import styled from "styled-components";
import { WerfenColor, White } from "../../../../Constants/ColorChart";

export const WrapperDiv = styled.div`

    min-height: 50vh;
    background: ${ WerfenColor };
    position: relative;
    z-index: 40;

    a {
        position: relative;
        display: inline-block;
        margin-top: 20px;
    }


    a[data-title] {
        color: transparent;

        &:hover::after {
            content: attr(data-title);
            position: absolute;
            top: -65px;
            left: calc(50% - 125px);
            color: ${ White } !important;
            font-size: 20px;
        }
    }
`;

export const SearchBox = styled.div`
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    height: calc(50vh - 50px);
    justify-content: center;
`;

export const LogoWrapper = styled.div`
    display: block;
    position: relative;
    max-width: 400px;
    width: 100%;
    box-sizing: border-box;
    height: auto;
    margin: 0 auto;
    padding: 20px 0px 20px 0px;
    @media (max-width: 500px) {
        padding: 20px 0;
    }
    @media (max-width: 992px) {
        padding: 0;
        width: 200px
    }
`;

export const RightButtonDiv = styled.div`
    position: absolute;
    z-index: 10;
    width: 9%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    right: 0;
    max-width: 150px;
    min-width: 50px;
`;
